import type { Entry } from 'contentful';
import { componentMapping } from './componentMapping';

type Props = {
    entry: Entry;
    [key: string]: unknown;
};

export function ComponentResolver(props: Props) {
    const { entry, ...otherProps } = props;

    const typeName = entry?.sys?.contentType?.sys.id as keyof typeof componentMapping;

    const Component = componentMapping[typeName];
    if (!Component) {
        return null;
    }

    const componentProps = entry.fields;

    return <Component {...componentProps} {...otherProps} />;
}
